import { CardRequest } from "./card.request";
import { CustomerRequest } from "./customer.request";

export class CustomerCreateRequest extends CustomerRequest{

    cards:CardRequest []

}